import { Injectable } from '@angular/core';
import { CacheService } from './cache.service';
import { Subscription } from 'rxjs';
import { TaskService } from '../app/tasks/task.service';
import { UIService } from '../app/ui.service';
import { AppConfiguration } from '../app/conf/app.configuration';
import { SubscriptionUtils } from '../utils/subscription.utils';
import { PropertyService } from '../app/properties/property.service';

@Injectable()
export class InitService {
  private initialized = false;
  protected subscriptionUtils: SubscriptionUtils;

  constructor(
    private cacheService: CacheService,
    private taskService: TaskService,
    private uiService: UIService,
    private appConfig: AppConfiguration,
    private propertyService: PropertyService
  ) {
    this.subscriptionUtils = new SubscriptionUtils();
  }

  public init(): void {
    if (!this.initialized) {
      if (this.appConfig.getValue('ENS.showAlert')) {
        // mostrar alerta ENS
        this.uiService.showENSAlertMessage(true);
      }
      if (this.appConfig.getValue('ENS.showLoginAlert')) {
        // mostrar alerta ENS
        this.uiService.showENSAlertMessage(false);
      }
      // inicializamos el hilo de consulta de tareas
      this.taskService.initTasksThread();
      this.subscriptionUtils.registerSubscription(
        this.cacheService.init().subscribe()
      );
      this.subscriptionUtils.registerSubscription(
        this.propertyService.init().subscribe()
      );
      this.initialized = true;
    }
  }

  public finish(): void {
    try {
      this.taskService.stopTasksThread();
    } catch {}
    try {
      // limpiar cache
      this.cacheService.clear();
      this.propertyService.clear();
    } catch {}
    this.subscriptionUtils.unregisterAllSubscriptions();
    this.initialized = false;
  }
}
